export const formatPriceNumber = (price?: number): string => {
  if (typeof price === "undefined") {
    return ""
  }
  if (Number.isInteger(price)) {
    return price.toString()
  }
  return price.toFixed(2)
}
